module.exports = "<div type=\"text\" id=\"price-filter\"></div>\n<span id=\"slider-indicator\">0 - 20000</span>"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/price-filter/price-filter.component.html
// module id = ../../../../../src/app/_components/price-filter/price-filter.component.html
// module chunks = main